import './index.css';
import 'overlayscrollbars/overlayscrollbars.css';
import 'fontsource-roboto';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { init } from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import { createAxiosInterceptor } from 'app/axios';
import { store } from 'app/store';
import { isProd } from 'app/utils/utils';
import { Router } from 'app/routing/components/Router';
import { install } from 'resize-observer';
import reportWebVitals from './reportWebVitals';

createAxiosInterceptor(store);

if (!window.ResizeObserver) install();

if (isProd()) {
  init({
    dsn:
      'https://6d1ac68d8b304b46851bca4996f67949@o1023094.ingest.sentry.io/6105206',
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 0,
    release: process.env.npm_package_version,
    ignoreErrors: ['ResizeObserver loop'],
  });
}

const root = createRoot(document.getElementById('root')!);
root.render(
  <Provider store={store}>
    <Router />
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
